import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { apiService } from '../services/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '../contexts/AuthContext';

const EmailVerifyPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const token = searchParams.get('token');
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage(t('emailVerification.invalidLink', '驗證連結無效'));
      return;
    }
    apiService.users.verifyEmail(token)
      .then(() => {
        setStatus('success');
        setMessage(t('emailVerification.successMsg', '電郵驗證成功！'));
        refreshUser?.();
      })
      .catch((err: any) => {
        setStatus('error');
        setMessage(err?.response?.data?.message ?? t('emailVerification.failMsg', '驗證失敗，連結可能已過期'));
      });
  }, [token]);

  return (
    <div className="flex-1 flex items-center justify-center px-4 py-12">
      <Card className="w-full max-w-sm">
        <CardContent className="flex flex-col items-center gap-4 py-10 text-center">
          {status === 'loading' && <Loader2 className="w-12 h-12 animate-spin text-primary" />}
          {status === 'success' && <CheckCircle2 className="w-12 h-12 text-green-500" />}
          {status === 'error' && <XCircle className="w-12 h-12 text-destructive" />}
          <p className="font-medium">{message}</p>
          {status !== 'loading' && (
            <Button onClick={() => navigate('/home')}>
              {t('common.backHome', '返回主頁')}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailVerifyPage;
